import { render, staticRenderFns } from "./virtual-sport-game.vue?vue&type=template&id=4c3cbb70"
import script from "./virtual-sport-game.vue?vue&type=script&lang=js"
export * from "./virtual-sport-game.vue?vue&type=script&lang=js"
import style0 from "./virtual-sport-game.vue?vue&type=style&index=0&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/pages/sitepages/virtual-sports/virtual-sport-game/virtual-sport-game.vue
// module id = 4cj7
// module chunks = 0